import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Chip, useTheme } from "@mui/material/index";
import { CBOmissionType, IFormValues } from "../../types";

const CBDigitalIdentity = () => {

    const theme = useTheme();
    const { t } = useTranslation("customerbase");
    const { control } = useFormContext<IFormValues>();

    const getChipColor = (value: string | null) => {
        const val = value == CBOmissionType.OMISSION_DASH ? '' : value;

        return !!val ? theme.palette.success.main : theme.palette.grey.A400;
    }


    return (
        <>
           <Controller
                control={control}
                name="cbDetails.idpUid"
                render={({field}) => (
                    <Chip
                        label={t("idpUid")}
                        sx={{color: "white", backgroundColor: getChipColor(field.value)}}                    
                    />
                )}             
            />
        </>
    );

}

export default CBDigitalIdentity;